import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
    fetchMunicipalities,
    fetchPopulation,
} from '../../../project/project-tva-bosse-samleside/project-tva-bosse-actions';

export const useAntallBosser = ({ municipality, county }) => {
    const { baseUrl, tvaEventId, p3aEventId } = useSelector((state) => ({
        baseUrl: state.baseURL,
        tvaEventId: state.campaigns.tvaEventId,
        p3aEventId: state.campaigns.p3aEventId,
    }));

    const [isLoading, setIsLoading] = useState(true);
    const [hasFailed, setHasFailed] = useState(false);
    const [antallBosser, setAntallBosser] = useState(0);
    const [innsamletTotalt, setInnsamletTotal] = useState(0);
    const [innsamletPerPerson, setInnsamletPerPerson] = useState(0);

    async function fetchData() {
        setHasFailed(false);
        setIsLoading(true);
        try {
            const fetchMunicipalitiesPromise = fetchMunicipalities({
                eventIds: [tvaEventId, p3aEventId].filter((id) => !!id),
                baseUrl,
            }).then((result) => result.json());

            const fetchPopulationPromise = fetchPopulation({ baseUrl, county, municipality });
            const fetchMunicipalitiesResult = await fetchMunicipalitiesPromise;
            const populationResult = await fetchPopulationPromise;

            const topMunicipalities = fetchMunicipalitiesResult?.aggregationResults?.group_by_municipality ?? [];
            const antall = topMunicipalities.find((m) => m.key === municipality).count;
            const innsamlet = topMunicipalities.find((m) => m.key === municipality).sum;
            const population = populationResult?.municipality?.[municipality];

            if (population) {
                setInnsamletPerPerson(innsamlet / population);
            }

            setInnsamletTotal(innsamlet);
            setAntallBosser(antall);
        } catch (e) {
            setHasFailed(true);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (municipality && county) {
            fetchData();
        }
    }, [municipality, county]);

    return { isLoading, antallBosser, hasFailed, innsamletPerPerson, innsamletTotalt };
};
